import { Card, CardContent, CardHeader, CircularProgress, Grid } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import OpdCardAdmin from 'examples/Cards/OpdCard/OpdCardAdmin'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import { useEffect, useState } from 'react'
import userStore from 'store/userStore'
import Tambah from './Tambah'
import { Route, Routes } from 'react-router-dom'
import Swal from 'sweetalert2'
import { postDelete } from 'global/postFunc'
import Detail from './Detail'

const DaftarOpd = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="detail" element={<Detail />} />
        </Routes>
    )
}

const Data = () => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [updating, setUpdating] = useState(false)

    const reqOpd = () => {
        setLoading(true)
        postDataWithResponse(
            '/opd/filter',
            {
                jenis: '',
                nama: '',
            },
            null,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    const hapusData = (id) => {
        Swal.fire({
            title: `Hapus Data?`,
            text: `Data ${id} akan Dihapus`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/sa/opd/delete',
                    {
                        _method: 'DELETE',
                        id: id,
                    },
                    decryptedUser,
                    null,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Daftar OPD</ArgonTypography>
                        }
                        action={
                            <Tambah
                                decryptedUser={decryptedUser}
                                updating={updating}
                                setUpdating={setUpdating}
                                addReq={addReq}
                            />
                        }
                    />
                    <CardContent>
                        {
                            loading ?
                                <ArgonBox align="center">
                                    <CircularProgress />
                                </ArgonBox>
                                :
                                <Grid container spacing={4} mt={1}>
                                    {
                                        data.map((dt, index) => (
                                            <Grid item xs={12} xl={6} key={index}>
                                                <OpdCardAdmin
                                                    data={dt}
                                                    decryptedUser={decryptedUser}
                                                    updating={updating}
                                                    setUpdating={setUpdating}
                                                    addReq={addReq}
                                                    hapus={hapusData}
                                                />
                                            </Grid>
                                        ))
                                    }
                                </Grid>

                        }
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default DaftarOpd